import nBossConnection from 'modules/base/service/nBossConnection';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import EdtDynamicCheckTableService from '../service/EdtDynamicCheckTableService';

const config = {
	key: 'edtDynamicCheckTable',
	topic: 'edtDynamicCheck',
	service: EdtDynamicCheckTableService,
	editFormState: item => `/edt-dynamic-check/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['search', 'refresh', 'new'],
	rowAction: ['exportData', 'modify', 'delete'],
	exportData: {
		tooltip: 'Export to XLSX',
		link: item => `${nBossConnection.basePath}edtDynamicCheckTableControl/exportToXlsx?id=${item.id}`
	},
	columns: [
		{
			key: 'name'
		},
		{
			key: 'modelName'
		},
		{
			key: 'Log'
		},
		{
			key: 'sequenceStartItemId'
		},
		{
			key: 'readInterval'
		},
		{
			key: 'timeWindow'
		},
		{
			key: 'maxIterations'
		},
		{
			key: 'minSampleCountForVarianceCheck'
		}
	]
};

function EdtDynamicCheckTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('edtDynamicCheckTable', reducer('edtDynamicCheckTable'))(EdtDynamicCheckTable);
